/**
 * DetectOSController
 *
 * @author Benjamin Stiber <benjamin.stiber@pluswerk.ag>
 */
Pluswerk.PlusProject.Utility.DetectOSController = function () {
  var appVersion = navigator.appVersion;
  var os = '';
  if (appVersion.indexOf('Win') > -1) {
    os = 'windows';
  } else if (appVersion.indexOf('iPhone') > -1
    || appVersion.indexOf('iPad') > -1
    || appVersion.indexOf('iPod') > -1) {
    os = 'ios';
  } else if (appVersion.indexOf('Mac') > -1) {
    os = 'mac';
  } else if (appVersion.indexOf('Android') > -1) {
    os = 'android';
  } else if (appVersion.indexOf('Linux') > -1) {
    os = 'linux';
  } else if (navigator.userAgent.indexOf("Edg") !== -1) {
    os = 'edge';
  } else if (navigator.userAgent.indexOf("Chrome") !== -1) {
    os = 'chrome';
  } else if (navigator.userAgent.indexOf("Safari") !== -1) {
    os = 'safari';
  } else if (navigator.userAgent.indexOf("Firefox") !== -1) {
    os = 'firefox';
  }

  $html.addClass(os);
};
